var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications-template"},[_c('h5',{staticClass:"heading-h5"},[_vm._v("NOTIFICACIONES")]),_c('ListNotifications',{ref:"list_notifications",attrs:{"isLoading":_vm.isLoading,"morePaginate":_vm.morePaginate,"notifications":_vm.notifications},on:{"onBottomReached":_vm.searchNextPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }